import React, { PureComponent } from 'react';
import style from './styles/style.module.css';


class HomePage extends PureComponent {
    render() {
        return (
            <section className={ style.page }>
                Admin Site!!
            </section>
        );
    }
}


export default HomePage;
